<template>
  <div class="flexCarousel">
    <div class="LySlider">
      <div class="lyInner" :style="{width: `${item.contents.length * (
        size ===  'LyGi' ? 507
        :size === 'LyMe' ? 307
        :size === 'LyKi' ? 267
        :size === 'LyHe' ? 248
        :size === 'LyDe' ? 227
        :size === 'LyMi' ? 167
        :size === 'LyNa' ? 127 : 'auto'
      )}px`}">
          <slot v-for="(bubble, b) in item.contents" :index="b" :bubble="bubble"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'size']
}
</script>
<style lang="scss">
.LySlider {
  overflow: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    height: 0;
    visibility: hidden;
  }
  .T1 {
    -webkit-box-flex: 1;
    flex: 1 0 0;
  }
  .lyInner {
    display: -webkit-box;
    display: flex;
    width: 100%;
  }
  .lyItem {
    -webkit-box-flex: 0;
    display: inherit;
    margin-left: 7px;
    &.LyGi {
      max-width: 386px!important;
    }
  }
  .lyItem + .lyItem {
    margin-left: 9px;
  }
  .lyInner::after {
    -webkit-box-flex: 0;
    flex: none;
    content: "";
    display: block;
    width: 7px;
    height: 1px;
  }
}
.lyInner {
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding-left: 50px;
}
</style>
